import { useState } from "react";
import clinicAPI from "../../../services/clinicApi";
import { canVoidManualPayment } from "../AdminPatients/clientSportDisplay";
import { Button, useToast } from "../../ui";

function voidConfirmMessage(payment) {
  if (payment?.membership_id) {
    return (
      "Удалить эту ручную оплату?\n\n" +
      "Сумма исчезнет из финансов. Если это единственная оплата по абонементу, " +
      "он снова станет «ожидает оплаты»."
    );
  }
  return (
    "Удалить эту ручную оплату?\n\n" +
    "Сумма исчезнет из финансов. Абонемент клиента не изменится."
  );
}

/** Удаление ошибочной ручной отметки. Оплаты через эквайринг — нельзя. */
export default function VoidManualPaymentButton({
  payment,
  onSuccess,
  size = "sm",
  variant = "secondary",
  label = "Удалить",
}) {
  const toast = useToast();
  const [busy, setBusy] = useState(false);

  if (!canVoidManualPayment(payment)) return null;

  const remove = async (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    if (!window.confirm(voidConfirmMessage(payment))) return;
    setBusy(true);
    try {
      const data = await clinicAPI.voidMembershipPayment(payment.id);
      if (data.reverted) {
        toast.success("Оплата удалена, абонемент снова ожидает оплаты");
      } else {
        toast.success("Оплата удалена");
      }
      onSuccess?.(data);
    } catch (err) {
      toast.error(err.response?.data?.error || "Не удалось удалить оплату");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      type="button"
      size={size}
      variant={variant}
      disabled={busy}
      onClick={remove}
    >
      {busy ? "…" : label}
    </Button>
  );
}
